import React from 'react';
import { ReferralWidget } from './widget';

export const ReferralPage: React.FC = () => <ReferralWidget />;

